if (!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.pickupStatusCC = this.querySelector('.pickup-status--cc');
      this.pickupStatusHD = this.querySelector('.pickup-status--hd');

      this.refreshHandler = this.handleRefreshBtnClick.bind(this);

      this.variantSku = this.dataset.variantSku;
      this.lastData = [];

      this.updateAvailability();
      const showDetailsBtn = this.querySelector('.js-show-pickup-info');
      if (showDetailsBtn) {
        showDetailsBtn.addEventListener('click', () => {
          document.querySelector('.js-pickup-drawer').open(showDetailsBtn);
        });
      }
    }

    connectedCallback() {
      window.addEventListener('custom:selected-location:change', ()=>{
        this.renderPickupInfo(this.lastData);
      });

      document.addEventListener('custom:selectedVariantUpdate', (e)=>{
        this.variantSku = e.detail.sku;
        this.updateAvailability();
      });
    }

    /**
     * Handles 'click' events on the refresh button.
     */
    handleRefreshBtnClick() {
      this.updateAvailability(this.dataset.variantId);
    }

    /**
     * Gets pick up availability for the current variant.
     * @param {string} variantId - Current variant id.
     */
    async updateAvailability() {
      await fetch(findinstoreAPIendpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({sku: this.variantSku}),
      }).then((response) => response.json())
      .then((inventory) => {
        if(!inventory[this.variantSku.toUpperCase()]) {
          throw new Error('Inventory data unavailable');
        }

        this.renderPickupInfo(inventory[this.variantSku.toUpperCase()]);
      })
      .catch((error)=>{
        this.classList.add('hidden');
        console.log(error);
      });
    }

    /**
     * Renders the pick up info.
     * @param {string} sectionHtml - Fetched section HTML.
     */
    renderPickupInfo(data) {
      if (this.variantSku.startsWith('GCS')) {
				console.debug('Temporarily skipping gift card SKUs x');
				return;
			}

      this.lastData = [...data];

      const hdLocation = data.find(location=>location.title == 'Head Office');
      const ccLocations = data.filter(location=>location !== hdLocation).sort((a,b)=>a.title.localeCompare(b.title));

      const preferredStore = localStorage.getItem('preferred_store')?.trim();
			const ccEnabled = preferredStore && preferredStore !== 'Home Delivery';

      const ccLocation = ccEnabled ? ccLocations.find(location=>location.title.includes(preferredStore)) : null;
      
      const ccAvailable = ccLocation ? ccLocation.qty > 0 : ccEnabled ? false : ccLocations.some(location=> location.qty > 0);
      const hdAvailable = hdLocation?.qty > 0;


      const pickupStatusCCText = this.pickupStatusCC.querySelector('p');
      const pickupStatusHDText = this.pickupStatusHD.querySelector('p');

      pickupStatusCCText.innerHTML = `${ccAvailable ? 'Available' : 'Not available'} for ${ccLocation || ccEnabled ? `Click & Collect - <strong>${(ccLocation?.title || preferredStore).replace('Click and Collect - ','')}` : '<strong>Click & Collect</strong>'}</strong>`;
      pickupStatusHDText.innerHTML = `${hdAvailable ? 'Available' : 'Not available'} for <strong>Home Delivery</strong>`

      this.pickupStatusCC.classList.toggle('unavailable', !ccAvailable);
      this.pickupStatusHD.classList.toggle('unavailable', !hdAvailable);

      this.classList.remove('hidden');

      const drawerContent = document.querySelector('.js-pickup-drawer .drawer__content');
      const locationsTable = `
        <table class="pickup-availability__stores-list">
          <thead>
            <tr>
              <th>Store</th>
              <th>Availability</th>
              <th>Stock</th>
            </tr>
          </thead>
          <tbody>
            ${[hdLocation, ...ccLocations].map(location=>{
              if(!location) return '';

              const qty = Math.max(0, location.qty);
              const stockLabel = qty > 3 ? 'In Stock' : qty >= 1 ? 'Low Stock' : 'Out of Stock';
              const stockClass = stockLabel.toLowerCase().replaceAll(' ', '-');
              const title = location.title == 'Head Office' ? 'Home Delivery' : location.title.replace('Click and Collect - ','');

              return `
                <tr>
                  <td>${title}</td>
                  <td class="${stockClass}">${stockLabel}</td>
                  <td>${qty}</td>
                </tr>
              `;
            }).join('')}
          </tbody>
        </table>
      `;

      drawerContent.innerHTML = locationsTable;

      const stockIndicator = document.querySelector('.stock-indicator');
      if(stockIndicator) {
        const stockIndicatorCount = stockIndicator.querySelector('.stock-indicator__count');
        if(!stockIndicatorCount) return;

        stockIndicatorCount.innerHTML = hdAvailable ? `Home delivery stock <span>(${hdLocation.qty})</span>` : 'Out of stock for home delivery';
        stockIndicator.classList.toggle('stock-indicator--out-of-stock', !hdAvailable)
        stockIndicator.classList.remove('hidden');
      }
    }

    /**
     * Renders a 'pick up unavailable' message.
     */
    renderUnavailableMsg() {
      this.innerHTML = '';
      this.appendChild(this.unavailableHtml);
      this.querySelector('.js-refresh').addEventListener('click', this.refreshHandler);
    }
  }

  customElements.define('pickup-availability', PickupAvailability);
}
